module.exports = __webpack_public_path__ + "static/media/eg.99dfda5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/eg.svg
// module id = 106
// module chunks = 0